export default class Labels {
  public static FIELD_REQUIRED = 'Field cannot be empty';
}